import { FormReviewData, PersonalInfo } from "@/types";
import { formatDate, calculateAge } from "@/utils/formatters";

interface PersonalInfoSectionProps {
  formData: FormReviewData;
}

export function PersonalInfoSection({ formData }: PersonalInfoSectionProps) {
  const personal: PersonalInfo =
    formData?.formData?.personal_info || ({} as PersonalInfo);

  return (
    <div className="info-card traveler-info">
      <h3>Traveler Information</h3>
      <div
        className="info-grid"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Full Name:
          </label>
          <span
            style={{
              color: "#1f2937",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {personal.passport_name_first} {personal.passport_name_middle}{" "}
            {personal.passport_name_last}
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Date of Birth:
          </label>
          <span style={{ color: "#1f2937" }}>
            {formatDate(formData?.dateOfBirth || personal.date_of_birth)} (
            {calculateAge(formData?.dateOfBirth || personal.date_of_birth)}{" "}
            years old)
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>Gender:</label>
          <span style={{ color: "#1f2937", textTransform: "capitalize" }}>
            {personal.gender || "Not specified"}
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>Email:</label>
          <span
            style={{
              color: "#1f2937",
              wordBreak: "break-all",
              overflowWrap: "break-word",
            }}
          >
            {personal.email}
          </span>
        </div>

        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Phone (Daytime):
          </label>
          <span
            style={{
              color: "#1f2937",
              wordBreak: "break-all",
              overflowWrap: "break-word",
            }}
          >
            {personal.phone_daytime}
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Address:
          </label>
          <span
            style={{
              color: "#1f2937",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {personal.street_address}, {personal.city}, {personal.state}{" "}
            {personal.zip_code}, {personal.country}
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Physical Details:
          </label>
          <span style={{ color: "#1f2937" }}>
            {personal.weight} {personal.weight_unit}
          </span>
        </div>
      </div>
    </div>
  );
}
